import { render, staticRenderFns } from "./inboxdetails.vue?vue&type=template&id=6b967185&"
import script from "./inboxdetails.vue?vue&type=script&lang=js&"
export * from "./inboxdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports